// @flow

import React from "react";
import { localize } from "redux-i18n";

import type { SelectedTask } from "@modules/reporting/reducer/tasks/types";

type OwnProps = $Exact<{
  selectedTask: SelectedTask,
}>;

type Props = $Exact<{
  ...PropsFromLocalize,
  ...OwnProps,
}>;

export const RTWEmployeeDetailsView = (props: Props) => (
  <div className="w-100">
    <div className="d-flex small-font-size justify-content-between mb-2">
      <div className="w-50 with-border pt-2 mr-2">{props.t("EMPLOYEE_NAME")}:</div>
      <div className="w-50 with-border pt-2">
        {((props.selectedTask || {}).employee || {}).name || props.t("N/A")}
      </div>
    </div>
    <div className="d-flex small-font-size justify-content-between mb-2">
      <div className="w-50 with-border pt-2 mr-2">{props.t("EMPLOYEE_REF")}:</div>
      <div className="w-50 with-border pt-2">
        {((props.selectedTask || {}).employee || {}).employeeRefPrimary || props.t("N/A")}
      </div>
    </div>
    <div className="d-flex small-font-size justify-content-between mb-2">
      <div className="w-50 with-border pt-2 mr-2">{props.t("JOB_TITLE")}:</div>
      <div className="w-50 with-border pt-2">
        {((props.selectedTask || {}).employeePositions || []).map(ou => ou.jobTitle).join(", ") ||
          props.t("N/A")}
      </div>
    </div>
    <div className="d-flex small-font-size justify-content-between mb-2">
      <div className="w-50 with-border pt-2 mr-2">{props.t("DEPARTMENT")}:</div>
      <div className="w-50 with-border pt-2">
        {((props.selectedTask || {}).organisationalUnits || []).map(ou => ou.name).join(", ") ||
          props.t("N/A")}
      </div>
    </div>
    <div className="d-flex small-font-size justify-content-between mb-2">
      <div className="w-50 with-border pt-2 mr-2">{props.t("BRADFORD_SCORE")}:</div>
      <div className="w-50 with-border pt-2">{props.selectedTask.bradfordFactor}</div>
    </div>
  </div>
);

export default localize()(RTWEmployeeDetailsView);
